export default "__VITE_ASSET__CN7eI9_L__"